(() => {
  const selector = '.kr-all-rugs-paths-v2';
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function initPathways(root) {
    if (!root || root.dataset.mobileStoryReady === 'true') return;

    const rail = root.querySelector('.kr-all-rugs-paths-v2__routes');
    const cards = [...root.querySelectorAll('.kr-all-rugs-paths-v2__route')];
    const status = root.querySelector('.kr-all-rugs-paths-v2__mobile-status-text');
    const dots = [...root.querySelectorAll('.kr-all-rugs-paths-v2__mobile-dot')];
    if (!rail || cards.length < 2 || !status || dots.length !== cards.length) return;

    root.dataset.mobileStoryReady = 'true';
    let frame;

    function update() {
      if (!mobileQuery.matches) {
        cards.forEach((card) => {
          card.style.removeProperty('--kr-story-lift');
          card.style.removeProperty('--kr-story-turn');
          card.style.removeProperty('--kr-story-scale');
          card.style.removeProperty('--kr-story-shadow-y');
          card.style.removeProperty('--kr-story-shadow-blur');
          card.style.removeProperty('--kr-story-shadow-alpha');
        });
        frame = undefined;
        return;
      }

      const railRect = rail.getBoundingClientRect();
      const railCenter = railRect.left + railRect.width / 2;
      let activeIndex = 0;
      let closestDistance = Infinity;

      cards.forEach((card, index) => {
        const cardRect = card.getBoundingClientRect();
        const distance = cardRect.left + cardRect.width / 2 - railCenter;
        const normalized = Math.max(-1, Math.min(1, distance / cardRect.width));
        const closeness = 1 - Math.abs(normalized);
        const restingTurn = index % 2 === 0 ? -4 : 4;

        card.style.setProperty('--kr-story-lift', `${(-6 * closeness).toFixed(2)}px`);
        card.style.setProperty('--kr-story-turn', `${(restingTurn * Math.abs(normalized)).toFixed(2)}deg`);
        card.style.setProperty('--kr-story-scale', (1 + 0.055 * closeness).toFixed(3));
        card.style.setProperty('--kr-story-shadow-y', `${(18 + 8 * closeness).toFixed(1)}px`);
        card.style.setProperty('--kr-story-shadow-blur', `${(18 + 7 * closeness).toFixed(1)}px`);
        card.style.setProperty('--kr-story-shadow-alpha', `${(38 + 10 * closeness).toFixed(1)}%`);

        if (Math.abs(distance) < closestDistance) {
          closestDistance = Math.abs(distance);
          activeIndex = index;
        }
      });

      status.textContent = `Swipe · ${activeIndex + 1} / ${cards.length}`;
      dots.forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      frame = undefined;
    }

    function requestUpdate() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    function showCard(index) {
      const card = cards[index];
      const left = card.offsetLeft - (rail.clientWidth - card.clientWidth) / 2;
      rail.scrollTo({ left, behavior: 'smooth' });
    }

    rail.addEventListener('scroll', requestUpdate, { passive: true });
    dots.forEach((dot, index) => dot.addEventListener('click', () => showCard(index)));
    mobileQuery.addEventListener('change', requestUpdate);
    new ResizeObserver(requestUpdate).observe(rail);
    requestUpdate();
  }

  function initAll(scope = document) {
    scope.querySelectorAll(selector).forEach(initPathways);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
